import {
  fetchCountryData,
  fetchStateOrProvinceData,
  fetchCountyData,
  fetchCityData,
  fetchPostalCodeData,
} from '@bingads-webui-campaign/overview-cards-common';

export function fetchLocationData({
  cid, aid, campaignId, dateRange, metric,
}) {
  const countryData = fetchCountryData({
    cid, aid, campaignId, dateRange, metric,
  });

  const stateOrProvinceData = fetchStateOrProvinceData({
    cid, aid, campaignId, dateRange, metric,
  });

  const countyData = fetchCountyData({
    cid, aid, campaignId, dateRange, metric,
  });

  const cityData = fetchCityData({
    cid, aid, campaignId, dateRange, metric,
  });

  const postalCodeData = fetchPostalCodeData({
    cid, aid, campaignId, dateRange, metric,
  });

  return {
    fetchCountryData: countryData,
    fetchStateOrProvinceData: stateOrProvinceData,
    fetchCountyData: countyData,
    fetchCityData: cityData,
    fetchPostalCodeData: postalCodeData,
  };
}
